import React, { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { classNames } from "../../helpers";
import { useLocalStorage } from "../../hooks";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../redux/reducers/dashboardReducer";
import { clearSchoolData } from "../../redux/reducers/schoolReducer";
import * as userActions from "../../redux/reducers/userReducer";
import { userState } from "../../redux/reducers/userReducer";


import { ArrowDownIcon, ArrowUpIcon, BanknotesIcon, ChevronDownIcon, ShoppingCartIcon, TicketIcon } from '@heroicons/react/20/solid';
import { TwListBox, TwMainLayout } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { setGlobalLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForUsers } from "../../utils/confighelpers";
import { dashboardStatsFilter } from "../../utils/constants";
import RecentEventBooking from "../businessProfile/booking/RecentEventBooking";
import UpcomingEventActivites from "../businessProfile/UpcomingEventActivites";
import { useTranslation } from "react-i18next";


export default function Home({ }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userReduxState = useSelector(userState);
  const dashboardReduxState = useSelector(dashboardState);
  const [dashboardStatistics, setDashboardStatistics] = React.useState([
    { id: 1, name: t("bookings.totalBookingTitle"), stat: '0', icon: ShoppingCartIcon, change: '0%', changeType: 'increase' },
    { id: 2, name: t("myEvents.totalTicketsSold"), stat: '0', icon: TicketIcon, change: '0%', changeType: 'increase' },
    { id: 3, name: 'Total Earning', stat: '0', icon: BanknotesIcon, change: '0%', changeType: 'increase' },
  ]);
  const [dashboardStatisticsResponse, setDashboardStatisticsResponse] = React.useState({});
  const [backgroundForHome, setBackgroundForHome] = React.useState(false);
  const [dashboardFilter, setDashboardFilter] = React.useState('today');

  const getUserInfo = async () => {
    const config = {
      method: "get",
      url: `${getUrlForUsers()}getUserInfo`,
      headers: {
        "x-access-token": userToken,
      },
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config).catch(async (e) => {
      console.error("Session Has Expired");
      if (e.response && (e.response.status === 401 || e.response.status === 502)) {
        console.error("Session Has Expired");
        localStorage.removeItem("userToken");
        localStorage.removeItem("persist:root");
        dispatch(userActions.clearUserData());
        dispatch(clearSchoolData());
        dispatch(dashboardActions.clearDashboardData());
        await setUserToken("");
        window.location.href = "/";
      }
    });
    dispatch(setGlobalLoading(false));
    if (request.data.statusCode === 200) {
      const userData = request.data.data;

      dispatch(userActions.setUserData(userData));
      if (userData.onBoardingStep === 0 || userData.onBoardingStep === false) {
        if (userData.isVerified == true) {
          delete userData._id;
          dispatch(userActions.setOnBoardingData(
            {
              ...userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : {},
              ...userData,
              name: userData.fullName,
              sentFromSignupComplete: true,
              from: "list",
            },
          ));
          navigate("/on-bording", { /** new on-bording **/
            state: {
              ...userData,
              name: userData.fullName,
              sentFromSignupComplete: true,
              from: "list",
            },
          })
        } else {
          await Logout("");
        }
      } else if (userData.onBoardingStep === 1) {
        setBackgroundForHome(false)
        dispatch(userActions.setOnBoardingData(
          {
            ...userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : {},
            ...userData,
            name: userData.fullName,
            sentFromSignupComplete: true,
          },
        ));
        navigate("/on-bording", { /** new on-bording **/
          state: {
            ...userData,
            sentFromSignupComplete: true,
            name: userData.fullName,
          },
        })
      } else if (userData.onBoardingStep === 2) {
        dispatch(userActions.setOnBoardingData(
          {
            ...userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : {},
            ...userData,
            name: userData.fullName,
          },
        ));
        let nextUrl = "/my-subscription"
        navigate(nextUrl, {
          state: {
            ...userData,
            from: "onbording",
            sentFromVerifyEmail: true,
            address: {}
          },
        })
      } else if (userData.onBoardingStep === 3) {

        setBackgroundForHome(true)
        if (request.data.data?.businessType) {
          if (request.data.data?.businessType !== userReduxState.businessType) {
            await dispatch(userActions.setBusinessType(request.data.data?.businessType));
            setTimeout(() => {
              window.location.href = "/";
            }, 1000);
          }
        } else {
          await dispatch(userActions.setBusinessType("event"));
          await updateUserProfile()
        }
      }
    }
  }

  const Logout = async () => {
    try {
      await axiosInstance.put(
        `${getUrlForUsers()}logoutUser`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": userToken,
          },
        }
      );
    } catch (err) {
    } finally {
      localStorage.removeItem("userToken");
      localStorage.removeItem("persist:root");
      dispatch(userActions.clearUserData());
      dispatch(clearSchoolData());
      dispatch(dashboardActions.clearDashboardData());
      await setUserToken("");
      window.location.href = "/";
    }
  };

  const fetchData = useCallback(async () => {
    getDashboardStatistics();
    getUserInfo();
  }, [])

  React.useEffect(() => {
    fetchData();
  }, []);

  const updateUserProfile = async () => {
    const requestConfig = {
      method: "put",
      url: `${getUrlForUsers()}updateProfile`,
      headers: {
        "x-access-token": userToken,
      },
      data: {
        businessType: userReduxState.businessType
      },
    };
    const response = await axiosInstance(requestConfig);
    if (response.status === 200) {
      if (response.data.statusCode === 403) {
      } else if (response.data.statusCode === 200) {

      }
    }
  };

  const getDashboardStatistics = async () => {
    const config = {
      method: "get",
      url: `${getUrlForUsers()}statistics`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const request = await axiosInstance.request(config);
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        setDashboardStatisticsResponse(request.data.data)
      }
    }
  };


  if (userToken === undefined || !userToken || userToken.length < 1) {
    // navigate("/", { replace: true });
  }

  React.useEffect(() => {
    navigate("/myschedule", { replace: true }); // comment if display Dashboard
  }, []);

  React.useEffect(() => {
    if (dashboardStatisticsResponse[dashboardFilter]) {
      let statistics = dashboardStatisticsResponse[dashboardFilter]

      setDashboardStatistics(
        [
          { id: 1, name: t("bookings.totalBookingTitle"), stat: statistics.totalBookings, icon: ShoppingCartIcon, change: `${parseFloat(statistics?.bookingChange || 0).toFixed(2)}%`, changeType: parseFloat(statistics.bookingChange) > 0 ? 'increase' : 'decrease' },
          { id: 2, name: t("myEvents.totalTicketsSold"), stat: statistics.totalTickets, icon: TicketIcon, change: `${parseFloat(statistics?.ticketChange || 0).toFixed(2)}%`, changeType: parseFloat(statistics.ticketChange) > 0 ? 'increase' : 'decrease' },
          { id: 3, name: 'Total Earning', stat: parseFloat(statistics.totalEarnings).toFixed(2), icon: BanknotesIcon, change: `${parseFloat(statistics?.earningChange || 0).toFixed(2)}%`, changeType: statistics.earningChange && parseFloat(statistics.earningChange) > 0 ? 'increase' : 'decrease' },
        ]
      );
    }

    // }, [dashboardStatisticsResponse]);
  }, [dashboardFilter, dashboardStatisticsResponse]);

  return (
    <TwMainLayout
      headTitle={"Dashboard"}
      navBarTitleComp={
        <h3 className={"font-extrabold text-2xl text-primary"}>
          Dashboard
        </h3>
      }
      children={<div className="flex flex-col gap-3 p-5">
        <div className={`flex flex-col gap-6`}>

          {(userReduxState.businessType === "event") ? (<UpcomingEventActivites />)
            : ("")}

          <div className="flex flex-col gap-4  border-2 border-bright-gray hover:border-primary rounded-lg">
            <div className="flex justify-between border-b-2 border-bright-gray p-5">
              <h3 className={"text-black text-lg font-bold"} >
                Statistics
              </h3>
              <div className="flex gap-2 justify-end items-center">
                <TwListBox
                  value={dashboardFilter}
                  options={dashboardStatsFilter}
                  dropdownArrow={(<ChevronDownIcon aria-hidden="true" className="size-5 text-black forced-colors:text-[Highlight]" />)}
                  onChange={(v) => {
                    setDashboardFilter(v.value);
                    // handleFilterChange({ target: { value: v.value } })
                  }}
                />
              </div>
            </div>
            <dl className="m-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {dashboardStatistics.map((item) => (
                <div
                  key={item.id}
                  className="relative overflow-hidden rounded-lg bg-white border border-bright-gray px-4 pb-5 pt-5 shadow sm:px-6 sm:pt-6"
                >
                  <dt>
                    <div className="absolute rounded-full bg-indigo-500 p-3">
                      <item.icon aria-hidden="true" className="size-6 text-white" />
                    </div>
                    <p className="ml-16 truncate text-sm font-medium text-gray-500">{item.name}</p>
                  </dt>
                  <dd className="ml-16 flex items-baseline ">
                    <p className="text-2xl font-semibold text-gray-900">{item.stat}</p>
                    <p
                      className={classNames(
                        item.changeType === 'increase' ? 'text-green-600' : 'text-red-600',
                        'ml-2 flex items-baseline text-sm font-semibold',
                      )}
                    >
                      {item.changeType === 'increase' ? (
                        <ArrowUpIcon aria-hidden="true" className="size-5 shrink-0 self-center text-green-500" />
                      ) : (
                        <ArrowDownIcon aria-hidden="true" className="size-5 shrink-0 self-center text-red-500" />
                      )}

                      <span className="sr-only"> {item.changeType === 'increase' ? 'Increased' : 'Decreased'} by </span>
                      {item.change}
                    </p>
                    {/* <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                    <div className="text-sm">
                      <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
                        {t("inputFieldsTitle.viewAll")}<span className="sr-only"> {item.name} stats</span>
                      </a>
                    </div>
                  </div> */}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
          {(userReduxState.businessType === "event") ? (
            <RecentEventBooking
              title={t("bookings.recentBookingTitle")}
              bookingType="teacherRecentBookings"
            />
          ) : ""}
        </div>
      </div>} />
  );
}
